import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getPeritos = async () => {
    let peritos = null;
    try {
        const response = await api.get(`usuario/listcontroller`, config);
        peritos = response.data.data;
    } catch (err) {}
    return peritos;
}